import AxiosInstance from 'utils/AxiosInstance'
import * as types from './constants'

export const setParentUrl = (parentUrl) => {
  return {
    type: types.SET_PARENT_URL,
    parentUrl,
  }
}
export const setLoading = (loading) => ({
  type: types.SET_LOADING,
  loading,
})

export const fetchSelfAssignableCourses = () => {
  return (dispatch) => {
    dispatch(setLoading(true))
    AxiosInstance.get(`/courses/self-assignable-courses`).then((courses) => {
      if (courses.length) {
        dispatch({
          type: types.SET_COURSES,
          courses: courses,
        })
      }
      dispatch(setLoading(false))
    })
  }
}

export const fetchSelfAssignedCourses = () => {
  return (dispatch) => {
    AxiosInstance.get(`/courses/self-assigned-courses`).then((data) => {
      const courses =
        data.status === 200 && data.message.length
          ? data.message.map((item) => {
              return {
                course_id: parseInt(item.course_id),
                created_by: item.created_by,
              }
            })
          : []
      dispatch({
        type: types.SET_ASSIGNED_COURSES,
        courses: courses,
      })
    })
  }
}

export const assignUserToCourse = (courseId, useAccessCode = false) => {
  return (dispatch, getState) => {
    const state = getState()
    AxiosInstance.post(
      `/courses/self-assign-course/${courseId}${
        useAccessCode ? '?useAccessCode=true' : ''
      }`
    ).then((data) => {
      if (data.status === 201) {
        dispatch({
          type: types.SET_ASSIGN_COURSE,
          course: {
            course_id: parseInt(courseId),
            created_by: state.auth.user.id,
          },
        })
      }
    })
  }
}

export const unAssignUserFromCourse = (courseId) => {
  return (dispatch) => {
    AxiosInstance.delete(`/courses/self-unassign-course/${courseId}`).then(
      (data) => {
        if (data.status === 200) {
          dispatch({
            type: types.SET_UNASSIGN_COURSE,
            course: courseId,
          })
        }
      }
    )
  }
}
